import { render, staticRenderFns } from "./message-modal.vue?vue&type=template&id=10a85a8a"
import script from "./message-modal.vue?vue&type=script&lang=js"
export * from "./message-modal.vue?vue&type=script&lang=js"
import style0 from "./message-modal.vue?vue&type=style&index=0&id=10a85a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports